import Feature from "ol/Feature";
import { HTMLPath } from "../footer/performance-report/performance-report.component";
import { PointsService } from "../services/points.service";
import {  NavaidDTOCalculation, PerformanceReportNavaidModel } from "./navaid";
import { ProcedureDTOCalculation, ProcedureModel } from "./procedure";
import { NavaidModel } from "./navaid";
import { ConfigurationDisplayModel, ConfigurationModel } from "./configuration";
import { LatLonDMS } from "./coord-dms";


export class PerformanceReportDTO{

  author: string = "";
  date: string;
  fileType: string = "pdf";
  navaidsTable: Array<PerformanceReportNavaidModel>;
  procedureTable : Array<ProcedurePerformanceReport>;

  procedure: ProcedureDTOCalculation;
  procedureModel: ProcedureModel;

  wayPointsInfoTable: Array<WayPointInfoDTO> = new Array<WayPointInfoDTO>();

  performanceTable: Array<SegmentDTO> = new Array<SegmentDTO>();
  runPlanningTable: Array<RunPlanningDTO> = new Array<RunPlanningDTO>();
  graphicInfo: Array<PairCoverageInfo> = new Array<PairCoverageInfo>();


  image: string;

  static map(report: PerformanceReportDTO, data: any,distanceUnit:string): PerformanceReportDTO{
    report.performanceTable = [];
    for(let i in data.segmentInformation){
      report.performanceTable.push(SegmentDTO.getHeader(i));
      for(let j in  data.segmentInformation[i]){
          report.performanceTable.push(SegmentDTO.map(data.segmentInformation[i][j]));
      }
    }
    let segmentNumber = 1;
    for(let i in data.wayPointInfo){
      if(report.procedureTable[segmentNumber-1] != undefined){
        report.wayPointsInfoTable.push(WayPointInfoDTO.getHeader(report.procedureTable[segmentNumber-1].id));
      }

      for(let j in data.wayPointInfo[i]){
        report.wayPointsInfoTable.push(WayPointInfoDTO.map(j,report.navaidsTable,data.wayPointInfo[i],distanceUnit));
      }
      segmentNumber += 1;
    }
    for(let i in data.graphicInfo){
      report.graphicInfo.push(PairCoverageInfo.map(data.graphicInfo[i]));
    }
    return report;
  }

  static setNavaidsTable(report: PerformanceReportDTO,navaids: NavaidDTOCalculation[], pointsService: PointsService,coordFormat: string){

    report.navaidsTable = new Array<PerformanceReportNavaidModel>();
    for(let feature of navaids){
      let navaid: PerformanceReportNavaidModel = new PerformanceReportNavaidModel();
      //let navaidModel: NavaidModel =pointsService.transformFeatureInNavaid(feature);
      navaid.navaidId = feature.id;
      navaid.name = feature.name;
      navaid.navaidType = feature.type;
      if(coordFormat == 'DMS'){
        let latLonDms : LatLonDMS = new LatLonDMS();
        navaid.latitude = latLonDms.getStringFromLat(feature.latitude)
        navaid.longitude = latLonDms.getStringFromLon(feature.longitude)
      }
      else{
        navaid.latitude  = Number(feature.latitude).toFixed(5);
        navaid.longitude = Number(feature.longitude).toFixed(5);
      }
      navaid.altitude = feature.elevation;
      navaid.doc = feature.doc;
      navaid.sectorized =  feature.sectorizations.length > 0 ? "yes": "no";
      navaid.channel = feature.channel;
      navaid.defineFrequenciesFromChannel();
      //pointsService.defineFrequenciesFromChannel(navaid);
      report.navaidsTable.push(navaid);
    }
  }







  static setProcedureTable(report: PerformanceReportDTO,procedurelegs:any,coordFormat:String){
    report.procedureTable = new Array<ProcedurePerformanceReport>();
    let i = 1;
    for(let leg of procedurelegs){
      let wpNumber;
      if(i == 1){
        wpNumber = 'WP1 / B1'
      }
      else{
        wpNumber = `WP${i} / E${i-1} / B${i}`
      }
      report.procedureTable.push(new ProcedurePerformanceReport(leg.startPoint,coordFormat,wpNumber));
      i++;
    }
    report.procedureTable.push(new ProcedurePerformanceReport(procedurelegs.at(-1).endPoint,coordFormat,`WP${i} / E${i-1}` ));
  }
  static setRunplanningTable(report: PerformanceReportDTO,htmlPaths:HTMLPath[]){
    report.runPlanningTable = new Array<RunPlanningDTO>();
    for(let i = 0; i < htmlPaths.length; i++){
      htmlPaths[i].runplanning.sequenceNumber =  i+1;
      report.runPlanningTable.push(htmlPaths[i].runplanning);
    }
  }
}

export class ProcedurePerformanceReport{
  wpNumber: string;
  id:string;
  name:string;
  wpType:string;

  latitude: string;
  longitude: string;
  altitude: number;
  notes: string;


  constructor(point:any,coordFormat:String,wpNumber){
    this.id = point.coordPoint.coordpointid;
    this.name = point.coordPoint.name;
    this.wpType = point.procedurecoordpointtype;
    this.wpNumber = wpNumber;
    if(coordFormat == 'DMS'){
      let latLonDms : LatLonDMS = new LatLonDMS();
      this.latitude = latLonDms.getStringFromLat(point.coordPoint.latitude)
      this.longitude = latLonDms.getStringFromLon(point.coordPoint.longitude)
    }
    else{
      this.latitude = point.coordPoint.latitude;
      this.longitude = point.coordPoint.longitude;
    }
    this.altitude = point.altitude;
  }



}

export class SegmentDTO{
  segmentID: String;
  navaid1ID: string;
  navaid2ID: string;

  navaid1UniqueID: string;
  navaid2UniqueID: string;

  startSubtendedAngle: number;
  endSubtendedAngle: number;

  minSubtendedAngle: number;
  maxSubtendedAngle: number;

  totalCoverage: String;
  notes: string;

  static getHeader(id:String):SegmentDTO{
    let segment: SegmentDTO = new SegmentDTO();
    segment.segmentID = "Segment "+id;
    return segment;
  }
  static map(pair : any):SegmentDTO{
    var segment :SegmentDTO = new SegmentDTO();
    segment.navaid1ID = pair.navaid1ID
    segment.navaid2ID = pair.navaid2ID
    segment.navaid1UniqueID = pair.navaid1UniqueID ;
    segment.navaid2UniqueID = pair.navaid2UniqueID;

    segment.startSubtendedAngle = +Number(pair.startSubtendedAngle*(180/Math.PI)).toFixed(3) ;
    segment.endSubtendedAngle = +Number(pair.endSubtendedAngle*(180/Math.PI)).toFixed(3) ;

    segment.minSubtendedAngle = +Number(pair.minSubtendedAngle*(180/Math.PI)).toFixed(3);
    segment.maxSubtendedAngle = +Number(pair.maxSubtendedAngle*(180/Math.PI)).toFixed(3);
    segment.totalCoverage = pair.totalCoverage ? "Total": "Partial";

    return segment;

  }
}

export class PairCoverageInfo{
  name: string;
  values:Array<Number> = new Array<Number>();
  distances: Array<Number> = new Array<Number>();
  static map(data:any): PairCoverageInfo{
    let info: PairCoverageInfo = new PairCoverageInfo();
    info.name = data.name;
    for(let i in data.value){
      info.values.push(data.value[i]);
      info.distances.push(data.distance[i]);
    }
    return info;
  }
}


export class RunPlanningDTO{
  sequenceNumber: Number;
  pathSpec: String;
  dem1:String;
  dem2:String;
  dem3:String;
  dem4:String;
  notes: String;
}



export class WayPointInfoDTO{

  waypointID: string;
  navaidID: string;
  name: string;
  type: string;

  shadowing: string;
  distance:number;
  azimute:number;

  static getHeader(id:string):WayPointInfoDTO{
    let waypoint: WayPointInfoDTO = new WayPointInfoDTO();
    waypoint.waypointID = id;
    return waypoint;
  }
  static getNameFromNavaid(id,navaidsTable: Array<PerformanceReportNavaidModel>):string{
    for(let navaid of navaidsTable){
      if(navaid.navaidId == id){
        return navaid.name;
      }
    }
    return "";
  }
  static map( id,navaidsTable: Array<PerformanceReportNavaidModel>,data: any,distanceUnit:string){
      let waypointInfo:WayPointInfoDTO = new WayPointInfoDTO();

      waypointInfo.distance = +Number(distanceUnit == 'NM' ? ConfigurationModel.metersToNm(data[id]['0']) : data[id]['0']).toFixed(3) ;
      waypointInfo.azimute = +Number(data[id]['1']).toFixed(3);
      waypointInfo.shadowing = data[id]['2'] > 0 ? "Possible": "";
      let idArray: string[] = id.split("##");

      waypointInfo.navaidID = idArray[1];
      waypointInfo.name =idArray[2] ;
      waypointInfo.type = idArray[3];
      return waypointInfo;
  }

}
